export const COLORS = {
    sky_blue: '#62AED5',
    light_gray: '#DADADA',
    background_gray: '#F5F5F5',
    gray: '#8391A1',
    blue_black: '#254366',
    font_black:'#17171B',
}
